const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getSessionQuery } from '@/features/identity/lib/get-session.query';
import { getOnboardingStatusQuery } from '@/features/onboarding/lib/queries';
import { getProfileQuery } from '@/features/settings/lib/get-profile.query';
import { redirectToLogin } from '@/app/lib/redirect-to-login';
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({
    context,
    location
  }) => {
    const sessionDeps = {
      controllers: {
        authController: context.deps.controllers.authController,
        onboardingController: context.deps.controllers.onboardingController,
        settingsController: context.deps.controllers.settingsController
      }
    };
    const session = await context.queryClient.ensureQueryData(getSessionQuery(sessionDeps));
    if (!session) {
      const next = `${location.pathname}${location.searchStr}`;
      await redirectToLogin(context.queryClient, next);
    }
    const status = await context.queryClient.ensureQueryData(getOnboardingStatusQuery(sessionDeps));
    if (status === 'complete' && location.pathname === '/onboarding') {
      throw redirect({
        to: '/dashboard'
      });
    }
    if (status === 'not_complete' && location.pathname !== '/onboarding') {
      throw redirect({
        to: '/onboarding'
      });
    }
  },
  loader: ({
    context
  }) => {
    context.queryClient.prefetchQuery(getProfileQuery({
      controllers: {
        settingsController: context.deps.controllers.settingsController
      }
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});